var ReactSelect = require("react-select");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");
var Glyphicon = require("components/utility/icons/Glyphicon");

class DistrictSearch extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			loading: true, searchTimer: null
		};
	}

	selectDistrict(selectedDistrict) {
		if (selectedDistrict == null) {
			this.props.onSelect(null);
		} else {
			this.props.onSelect(selectedDistrict);
		}
	}

	setDistrictSearchTimer(input, callback) {
		if (this.state.searchTimer) {
			clearTimeout(this.state.searchTimer);
		}
		this.state.searchTimer = setTimeout(this.getDistrictOptions, 500, input, callback);
	}

	getDistrictOptions(input, callback) {
		var searchParams = { q: input.trim(), embed: "district.schools" };
		var url = WhooosReadingServices.CanonicalSchools.url("/district/search", searchParams);

		if (input.trim().length == 0) {
			callback(null, { options: [] });
			return;
		}

		$.getJSON(url, function(data) {
			var options = _.map(data.districts, function(district) {
				return { value: district, label: district.name + " (" + district.schools.length + " schools)" }
			});

			callback(null, { options: options });
		});
	}

	optionRenderer(optionData, index) {
		
		return (
			<span className="districtOpDisplay">
				{ optionData.label }
			</span>
		);
	}

	render() {
		var placeholderText = "Search by district name";

		return (
			<div className="DistrictSearch">
				<ReactSelect.Async name="district-name" autoload={ false }
					optionRenderer={this.optionRenderer} keepInputCase={ true }
					value={ this.props.selectedDistrict } placeholder={ placeholderText }
					loadOptions={ this.setDistrictSearchTimer } onChange={ this.selectDistrict } />
			</div>
		)
	}
};

DistrictSearch.NOT_PRESENT = "not-present";

DistrictSearch.MANUAL_ENTRY = "manaul-entry";

DistrictSearch.propTypes = StrictPropTypes({
	toggleManual: PropTypes.func,
	selectedDistrict: PropTypes.object,
	onSelect: PropTypes.func,

});

module.exports = DistrictSearch;



// WEBPACK FOOTER //
// ./modules/components/org/roster/DistrictSearch.js